import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { STORAGE_PRODUCTS_CART } from "../../../utils/constants";

export default function Buscador(props) {

    const{ itemCartWhap } = props;

    const [departamentos, setDepartamentos] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [consultora, setConsultora] = useState([]);
    const [aceptar, setAceptar] = useState(false);
    
    

useEffect(() => {
    (async () => {
        await departamento();
      })();
}, [])

    const departamento = async () =>{
        const arrayDepartamentos = [];
        let config = {
            method: 'get',
            url: 'https://marykay.com.gt/buscadorElSalvador/departamento.php',
            headers: { }
          };
          
          axios(config)
          .then(function (response) {
            return response.data;
          }).then(response =>{
            
             let listaDepartamento = response.listaDepartamentos;
             for (let index = 0; index < listaDepartamento.length; index++) {
                let departamento = listaDepartamento[index]
                 arrayDepartamentos.push(departamento.departamento);
                 
             }

             setDepartamentos(arrayDepartamentos);
          })
          .catch(function (error) {
            console.log(error);
          });
    }

   const handleChange = async(event) => {
        let departamentoEscogido = event.target.value;
        //console.log(departamentoEscogido);
         
         const arrayMunicipios = [];
         let config = {
             method: 'get',
             url: `https://marykay.com.gt/buscadorElSalvador/municipio.php?id=${departamentoEscogido}` ,
             headers: { }
           };
           
           axios(config)
           .then(function (response) {
             return response.data;
           }).then(response =>{
               //console.log(response);
             
             let listaMunicipios = response.listaMunicipios;
              for (let index = 0; index < listaMunicipios.length; index++) {
                 let municipios = listaMunicipios[index]
                  arrayMunicipios.push(municipios.municipio);
                 
              }
 
              setMunicipios(arrayMunicipios);
           })
           .catch(function (error) {
             console.log(error);
           });

      }


      const handleChangeMunicipio = async(event) => {

        let municipioEscoguido = event.target.value;
       
         
         const arrayConsultora = [];
         let config = {
             method: 'get',
             url: `https://marykay.com.gt/buscadorElSalvador/buscador.php?id=${municipioEscoguido}` ,
             headers: { }
           };
           
           axios(config)
           .then(function (response) {
             return response.data;
           }).then(response =>{
             
             let listaConsultoras= response.listaConsultoras;
              for (let index = 0; index < listaConsultoras.length; index++) {
                 let consultora = listaConsultoras[index]
                 let datosConsultoras = {
                     nombre: consultora.nombre + " " + consultora.apellido,
                     correo: consultora.correo,
                     cel: consultora.celular
                 }
                 arrayConsultora.push(datosConsultoras);
                 
              }
 
              setConsultora(arrayConsultora);
           })
           .catch(function (error) {
             console.log(error);
           });

    }

const enviarMensaje = async(cel) => { 
    let celular = cel;
    const arraytext = [];
    const arrayLink = [];
    let inicioText = "Hola querida Consultora, vi estos productos en el folleto y me gustaría pedirlos contigo los productos son: %0A";
    let text;
    let linkEnvio;
    let completText; 
    itemCartWhap.map((item, index) =>{
      text =`El producto numero ${index+1}: ${item.name}, de estos necesito: ${item.cantidad} por favor,%0A`;
      arraytext.push(text);
      linkEnvio=`${item.id}/${item.cantidad}`;
      arrayLink.push(linkEnvio);
    })
    let linkComplet = `%0Alink para agregar los productos: https://marykay.sv/revistaagregarproductos/${arrayLink.join("/")}`
    completText  = `${inicioText}${arraytext.join("-")}${linkComplet}`;
    let numero = `503${celular}`;
    
    window.location.href=`https://api.whatsapp.com/send?phone='${numero}'&text=${completText}`;

    localStorage.removeItem(STORAGE_PRODUCTS_CART);
}

const aceptarTrato = () =>{
  setAceptar(!aceptar);
  
}
    return (
 <>
<div className="form-check form-check-inline">
  <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" defaultChecked={aceptar} onChange={aceptarTrato}/>
  <label className="form-check-label" for="inlineCheckbox1">
     <a className="underlineHover" href="https://marykay.sv/productos/garantia/"
               target="_blank" rel="noreferrer">
                Acepto términos y condiciones.
        </a>
  </label>
</div>
{
  !aceptar ? "" 
  : 
  <>
    <form>
  <div className="form-row align-items-center">
    <div className="col-auto my-1" />

      <label className="mr-sm-2" for="inlineFormCustomSelect">Departamento</label>
      <select className="custom-select mr-sm-2" id="departamento" name="departamento"  onChange={handleChange} >

        <option selected>Escogue un Departamento...</option>
        {!departamentos
        ? "Espere un momento por favor"
        : departamentos.map((item,index) =>{
            return(
                <>
                <option key={index} value={item}>{item}</option>
                </>
            );
        })

        }
      </select>
     
      { municipios.length === 0 ? " "
      : 
        <select className="custom-select mr-sm-2" id="municipio" name="municipio" onChange={handleChangeMunicipio} >
        <option selected>Escogue un Municipio...</option>
      
        { municipios.map( (item, index) =>{
            return(
                <>
                <option key={index} value={item}>{item}</option>
                </>
            );
        })

        }
        
      </select>
        }

    </div>
</form>
{consultora.length === 0 ? <h3>Por el momento no se han encontrado consultoras</h3>
        : <div className="table-responsive-xl">
             <table className="table">
        <caption>Escoguer Una consultora</caption>
        <thead>
          <tr>
            <th scope="col">Nombre</th>
            <th scope="col">Enviar Whatsapp</th>
          </tr>
        </thead>
        <tbody>
            {
               consultora.map((item,index) =>{
                return( 
                    <tr key={index}>
                    <td scope="col">{item.nombre}</td>
                    <td scope="col"> <button className="btn btn-primary" onClick={()=>enviarMensaje(item.cel)}>Enviar Mensaje</button></td>
                  </tr>
                );
                
            })
            }
          
        </tbody>
      </table> 
      </div>
        }

  </>
}

       
  </>
        
    )
}

